var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.despachos.length
      ? _c(
          "div",
          { staticStyle: { display: "flex", "justify-content": "center" } },
          [_c("span", [_vm._v("Não há despachos registrados.")])]
        )
      : _c(
          "div",
          [
            _c("span", { staticClass: "title-processo" }, [
              _vm._v("Dados do processo")
            ]),
            _vm._v(" "),
            _c(
              "el-collapse",
              {
                staticClass: "container-collapse",
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.active,
                  callback: function($$v) {
                    _vm.active = $$v
                  },
                  expression: "active"
                }
              },
              _vm._l(_vm.despachos, function(despacho) {
                return _c(
                  "el-collapse-item",
                  {
                    key: despacho.id,
                    attrs: { name: despacho.id, title: despacho.descricao }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: despacho.loading,
                            expression: "despacho.loading"
                          }
                        ]
                      },
                      [_c("Despacho", { attrs: { despacho: despacho } })],
                      1
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f0cea15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0cea15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Processo/Processo.vue
// module id = null
// module chunks = 